import { AnyRanking, DynamicRanking, FixedRanking } from './cohortModel';

export function isFixedRanking(ranking: AnyRanking): ranking is FixedRanking {
    return typeof (ranking as FixedRanking).comparison === 'string';
}

export function isDynamicRanking(ranking: AnyRanking): ranking is DynamicRanking {
    return Array.isArray((ranking as DynamicRanking).cohorts) && !isFixedRanking(ranking);
}
